export const getConfiguration = (state) => state.configuration
